export const IS_SAFARI = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

if(IS_SAFARI) {
  $('.js-check-safari').addClass('is-safari')
}